// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add all variables here */
:host {
  height: 50px;
  padding-top: 12px;
  background-color: #3e0523;
  display: block;
}
:host .container > div {
  color: #ffedd6;
  font-weight: 300;
  font-size: 14px;
}
:host .container > div > div:first-child {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
:host .container > div a {
  color: #ffedd6;
  display: flex;
  align-items: center;
}
:host .container > div a app-comments-icon {
  margin-right: 10px;
  color: #F7941E;
  font-size: 18px;
}
:host .container > div a i {
  margin-right: 10px;
}
:host .container > div a strong {
  font-weight: 600;
}

.header-top__info-links {
  gap: 40px;
}

.header-top__trygg-ehandel {
  display: flex;
  align-items: center;
  gap: 8px;
}

.header-top__trustpilot {
  display: flex;
  align-items: center;
}
.header-top__trustpilot ::ng-deep .trustpilot-widget {
  color: #ffedd6 !important;
}
.header-top__trustpilot ::ng-deep .trustpilot-widget * {
  color: #ffedd6 !important;
}

app-country-selector {
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/variables.scss","webpack://./src/app/content/layout/components/general/header/components/header-top/header-top.component.scss"],"names":[],"mappings":"AAAA,2BAAA;ACEA;EACE,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;AAAF;AAGI;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AADN;AAGM;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;AADR;AAIM;EACE,cAAA;EACA,aAAA;EACA,mBAAA;AAFR;AAIQ;EACE,kBAAA;EACA,cDtBI;ECuBJ,eAAA;AAFV;AAKQ;EACE,kBAAA;AAHV;AAOQ;EACE,gBAAA;AALV;;AAYA;EACE,SAAA;AATF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AATF;;AAYA;EACE,aAAA;EACA,mBAAA;AATF;AAYE;EACE,yBAAA;AAVJ;AAYI;EACE,yBAAA;AAVN;;AAeA;EACE,aAAA;EACA,mBAAA;AAZF","sourcesContent":["/* Add all variables here */\n\n@import \"bootstrap/scss/functions\";\n@import \"bootstrap/scss/variables\";\n\n$text-orange: #F7941E;\n$wine-red-light: #5c0a31;\n$wine-red-dark: #3d051f;\n$wine-text-color: #37041c;\n$light-grey: #efefef;\n$yellow-cta: #ff9812;\n$gold: #e0b55d;\n$color-cloud-grey: #F9F9F9;\n$color-grey: #d5d5d5;\n$color-almost-black: #212529;\n$stock-green: #60E040;\n\n$supervin-color-bordeaux: #3E0523;\n\n$color-charcoal-black: #000;\n$theme-colors: (\n  \"primary\": $yellow-cta,\n  \"secondary\": $secondary,\n  \"success\": $yellow-cta, //$success,\n  \"info\": $yellow-cta, //$info,\n  \"warning\": $warning,\n  \"danger\": $danger,\n  \"light\": $light,\n  \"dark\": $dark\n);\n\n$container-max-widths: (\n  xl: 1280px\n);\n\n$header-height: 100px;\n\n$border-divider: 1px solid $color-cloud-grey;\n$breadcrumb-height: 30px;\n\n@mixin supervin-box-shadow {\n  box-shadow: 1px 1px 5px 0 rgba(0,0,0,0.4);\n}\n\n@mixin btn-primary {\n\n  border-radius: 0;\n  text-transform: uppercase;\n  padding: 0.7rem 1.3rem;\n  font-size: 0.8rem;\n  background-color: $yellow-cta;\n  border: solid 1px $yellow-cta;\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  vertical-align: middle;\n  user-select: none;\n  line-height: 1.5;\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: none;\n  }\n}\n\n\n\n","@import \"src/variables\";\n\n:host {\n  height: 50px;\n  padding-top: 12px;\n  background-color: #3e0523;\n  display: block;\n\n  .container {\n    & > div {\n      color: #ffedd6;\n      font-weight: 300;\n      font-size: 14px;\n\n      & > div:first-child {\n        display: flex;\n        justify-content: flex-start;\n        align-items: center;\n      }\n\n      a {\n        color: #ffedd6;\n        display: flex;\n        align-items: center;\n\n        app-comments-icon {\n          margin-right: 10px;\n          color: $text-orange;\n          font-size: 18px;\n        }\n\n        i {\n          margin-right: 10px;\n        }\n\n        // Bold parts within text\n        strong {\n          font-weight: 600;\n        }\n      }\n    }\n  }\n}\n\n.header-top__info-links {\n  gap: 40px;\n}\n\n.header-top__trygg-ehandel {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.header-top__trustpilot {\n  display: flex;\n  align-items: center;\n\n  // Force Trustpilot widget text color to match header text\n  ::ng-deep .trustpilot-widget {\n    color: #ffedd6 !important;\n    \n    * {\n      color: #ffedd6 !important;\n    }\n  }\n}\n\napp-country-selector {\n  display: flex;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
